module.exports = __webpack_public_path__ + "media/images/homes/TipPooling-f7caddc54028632bfe3fd449328275f7.png";